import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-motivo-estado',
  templateUrl: './motivo-estado.component.html',
  styleUrls: ['./motivo-estado.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MotivoEstadoComponent implements OnInit {

  constructor(
      public dialogRef: MatDialogRef<MotivoEstadoComponent>,
      @Inject(MAT_DIALOG_DATA)
      public data: any

  ) { }

  ngOnInit() {
  }

}
